import { Divider, styled } from '@mui/material';

export const StyledDivider = styled(Divider)(({ theme }) => ({
  color: theme.colors.divider,
  '@media print': {
    display: 'none',
  },
}));
